import Layout from '@/layout/Index.vue'

export default [
  {
    path: '/wlFreight',
    meta: { title: '绩效统计' },
    component: Layout,
    children: [
      {
        path: '',
        meta: { title: '运费明细', activeMenu: '/wlFreight' },
        component: () => import('@/views/wlFreight/Index.vue')
      },
      {
        path: 'add',
        meta: { title: '运费明细新增', activeMenu: '/wlFreight' },
        component: () => import('@/views/wlFreight/Add.vue')
      },
      {
        path: 'edit',
        meta: { title: '运费明细编辑', activeMenu: '/wlFreight' },
        component: () => import('@/views/wlFreight/Add.vue')
      },
      {
        path: 'detail',
        meta: { title: '运费明细详情', activeMenu: '/wlFreight' },
        component: () => import('@/views/wlFreight/Detail.vue')
      }
    ]
  }
]
